import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import prefixPath from "../utils/prefixPath";
import { httpGet, httpPost, httpPut, httpDelete } from "../utils/http";

export default class {
  apiEndpoint = null;
  prefixPathApis = undefined;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
    this.prefixPathApis = new prefixPath(apiEndpoint);
  }

  checkInRecord(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/checkin`;
    return httpPost(apiUrl, data);
  }

  checkInRecordUpdate(_id, data) {
    data._id = _id;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/checkin`;
    return httpPut(apiUrl, data);
  }

  createRecord(data, optUserID) {
    data.optUserID = optUserID;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/`;
    return httpPost(apiUrl, data);
  }

  modifyRecord(_id, data, optUserID) {
    data.optUserID = optUserID;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}`;
    return httpPut(apiUrl, data);
  }

  purgeRecord(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}`;
    return httpDelete(apiUrl);
  }

  getRecord(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}`;
    return httpGet(apiUrl);
  }

  copyRecord(_id) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}/duplicate`;
    return httpPost(apiUrl);
  }

  getBulkRecord(ids) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/bulk/read`;
    return httpPost(apiUrl, { ids });
  }

  async getRecordListByPet(
    petID,
    clinic,
    options,
    petName,
    getResourcePath = true,
    referralList = false
  ) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let data = {
      petID,
      options,
    };
    petName ? (data.petName = petName) : "";
    referralList ? (data.referralList = true) : "";

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/record/getList/pet`;

    let res = await httpPost(apiUrl, data);
    if (res.code === 100000 && res.result && getResourcePath)
      this.prefixPathApis.prependRecordResourcePath(res.result, clinicID);
    return res;
  }

  getRecordListByDateTime(begin, end, fields = null) {
    let data = {
      begin,
      end,
      fields,
    };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/dateTime`;
    return httpPost(apiUrl, data);
  }

  getRecordListByConditions(conditions, fields = null) {
    let data = {
      conditions,
      fields,
    };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/conditions`;
    return httpPost(apiUrl, data);
  }

  getRecordByStatusUpdateDateTime(dateBegin, dateEnd) {
    let data = {
      dateBegin,
      dateEnd,
    };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/statusUpdateDateTime`;
    return httpPost(apiUrl, data);
  }

  getRecordListForInit(dateBegin, dateEnd) {
    let data = {
      dateBegin,
      dateEnd,
    };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/init`;
    return httpPost(apiUrl, data);
  }

  getTodoRecordDrugList(dateBegin) {
    let data = {
      dateBegin,
    };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/todoDrug`;
    return httpPost(apiUrl, data);
  }

  getTodoRecordExamList(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/todoExam`;
    return httpPost(apiUrl, data);
  }
  // getTodoRecordExamList(dateBegin) {
  //   let data = {
  //     dateBegin,
  //   };
  //   let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
  //     "CLINIC"
  //   )}/record/getList/todoExam`;
  //   return httpPost(apiUrl, data);
  // }

  getRecordBilling(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/billing`;
    return httpPost(apiUrl, options);
  }

  getRecordStat(options) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/getList/stat`;
    return httpPost(apiUrl, options);
  }

  assignRecordStatus(_id, type, status, optUserID) {
    let data = {
      type,
      status,
      optUserID,
    };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}/status`;
    return httpPut(apiUrl, data);
  }

  fixExamTaskSubmitStatus(_id, optUserID) {
    let data = {
      optUserID,
    };
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${_id}/fixExamTaskSubmit`;
    return httpPut(apiUrl, data);
  }

  saveDraftConflictLog(
    originalDraft,
    draft,
    masterRecord,
    combinedRecord,
    version,
    exception
  ) {
    let data = {
      originalDraft,
      draft,
      masterRecord,
      combinedRecord,
      version,
      exception,
    };
    let recordID = combinedRecord._id;
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${recordID}/conflictLog`;
    return httpPost(apiUrl, data);
  }

  uploadRecordFile(recordID, upload, taskID = null) {
    let formData = new FormData();
    Object.keys(upload).forEach((key) => {
      formData.append(key, upload[key]);
    });

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${recordID === "draftTempFiles" ? "/record/draftTempFiles" : recordID
      }/file`;
    if (taskID) apiUrl += `/${taskID}`;
    return httpPost(apiUrl, formData);
  }

  deleteRecordFile(recordID, delFileNames, all = false) {
    delFileNames = delFileNames.map((fileName) =>
      fileName.replace(/^.*\//g, "")
    );

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${recordID === "draftTempFiles" ? "/record/draftTempFiles" : recordID
      }/file`;
    if (all) apiUrl += `/all`;
    return httpDelete(apiUrl, delFileNames);
  }

  confirmRecordFile(recordID, objects) {
    let data = { objects };

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}${recordID}/file/confirm`;

    return httpPut(apiUrl, data);
  }

  generateRecordTicket(pocket, bookingID = undefined) {
    console.log('generateRecordTicket', pocket, bookingID)
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/ticket?pocket=${pocket}${bookingID ? `&bookingID=${bookingID}` : ''}`;
    return httpPost(apiUrl);
  }

  generateExtensionTask(docID, selectedItems, options) {
    // let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
    //   "CLINIC"
    // )}/record/${Crypto.encrypt(recordID, CryptoKey)}/idexxRequest`;

    let apiUrl;
    if (options && options.protocol === "socket") {
      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
        "CLINIC"
      )}/syncTool/request/idexx/socket?docID=${docID}`;
      if (options.syncToolID) {
        apiUrl += `&synctoolID=${options.syncToolID}`;
      }
    } else {
      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
        "CLINIC"
      )}/syncTool/request/idexx/request?docID=${docID}`;
    }
    return httpPost(apiUrl, { selectedItems });
  }

  generateEBMExtensionTask(docID, selectedItems, options) {
    // let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
    //   "CLINIC"
    // )}/record/${Crypto.encrypt(recordID, CryptoKey)}/idexxRequest`;

    let apiUrl;
    if (options && options.protocol === "socket") {
      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
        "CLINIC"
      )}/syncTool/request/ebm/writeWorklist/socket?docID=${docID}`;
      if (options.syncToolID) {
        apiUrl += `&synctoolID=${options.syncToolID}`;
      }
    }
    const data = {
      recordID: docID,
      selectedItems: selectedItems
    }
    return httpPost(apiUrl, data);
  }

  generateEBMWebviewerExtensionTask(docID, selectedItems, options) {
    // let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
    //   "CLINIC"
    // )}/record/${Crypto.encrypt(recordID, CryptoKey)}/idexxRequest`;

    let apiUrl;
    if (options && options.protocol === "socket") {
      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
        "CLINIC"
      )}/syncTool/request/ebm/getImage/socket?docID=${docID}`;
      if (options.syncToolID) {
        apiUrl += `&synctoolID=${options.syncToolID}`;
      }
    }
    const data = {
      recordID: docID,
      selectedItems: selectedItems,
      options: options
    }
    return httpPost(apiUrl, data);
  }

  generateEPSPIExtensionTask(docID, selectedItems, options) {
    // let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
    //   "CLINIC"
    // )}/record/${Crypto.encrypt(recordID, CryptoKey)}/idexxRequest`;

    let apiUrl;
    if (options && options.protocol === "socket") {
      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
        "CLINIC"
      )}/syncTool/request/ebmEPSPI/writeWorklist/socket?docID=${docID}`;
      if (options.syncToolID) {
        apiUrl += `&synctoolID=${options.syncToolID}`;
      }
    }
    const data = {
      recordID: docID,
      selectedItems: selectedItems
    }
    return httpPost(apiUrl, data);
  }

  generateEPSPIWebviewerExtensionTask(docID, selectedItems, options) {
    
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/syncTool/request/ebmEPSPI/getImageWebviewer?docID=${docID}`;

    const data = {
      recordID: docID,
      selectedItems: selectedItems,
      options: options
    }
    return httpPost(apiUrl, data);
  }

  generateEPSPIDicomExtensionTask(docID) {

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/syncTool/request/ebmEPSPI/getImage`;

    const data = {
      recordID: docID,      
    }
    return httpPost(apiUrl, data);
  }

  generateSynctoolGetLogTask(data,options) {
    let apiUrl;
    if (options && options.protocol === "socket") {
      apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
        "CLINIC"
      )}/syncTool/request/getlogs/socket?synctoolID=${options.syncToolID}`;     
    }

    return httpPost(apiUrl, data);
  }

  generateVetScanExtensionTask(docID, selectedItems) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/syncTool/request/vetScan?docID=${docID}`;
    return httpPost(apiUrl, { selectedItems });
  }

  getRecordDateTime(recordIDs) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/bluk/read/dateTime`;
    return httpPost(apiUrl, recordIDs);
  }

  getRecordHistoryDrug(petID, timeRange, page) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/record/drug/history?petID=${petID ? Crypto.encrypt(petID, CryptoKey) : ""
      }`;
    return httpPost(apiUrl, { timeRange, page });
  }
}
